import { useState } from "react";

export const useTableActions = (tableApis, onTableUpdate) => {
  const [viewData, setViewData] = useState(null);
  const [showViewMore, setShowViewMore] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [dropdownIndex, setDropdownIndex] = useState(null);

  const handleActionClick = async (action, row, headers) => {
    console.log("Action clicked:", action, "Row:", row);

    if (action === "View") {
      try {
        console.log("Viewing invoice:", row);
        setViewData(row);
        setShowViewMore(true);
      } catch (err) {
        console.error("Error viewing invoice:", err);
      }
    } else if (action === "Edit") {
      try {
        console.log("Editing invoice:", row);
        setEditData(row);
        setShowEdit(true);
      } catch (err) {
        console.error("Error setting up edit for invoice:", err);
      }
    } else if (action === "Delete") {
      try {
        if (
          window.confirm(
            `Are you sure you want to delete invoice ${row.invoice_number}?`
          )
        ) {
          await tableApis.deleteById(row.invoice_number);
          if (onTableUpdate) onTableUpdate();
        }
      } catch (err) {
        console.error("Error deleting invoice:", err);
      }
    }
  };

  const toggleDropdown = (index) => {
    setDropdownIndex(index === dropdownIndex ? null : index);
  };

  const closeDropdown = () => setDropdownIndex(null);

  return {
    viewData,
    showViewMore,
    showEdit,
    editData,
    dropdownIndex,
    handleActionClick,
    toggleDropdown,
    closeDropdown,
    setShowViewMore,
    setShowEdit,
    setEditData,
    setViewData,
  };
};
